export default __webpack_public_path__ + "37c746510da3900d4dbc472f5520d5e0.png";